import React, { memo } from 'react';
import { Icon } from 'antd';
import cn from 'classnames';
import { ReactComponent as NotebookIcon } from '../../../../../../../resource/NoteBookIcon.svg';
import EllipsisTextWithTooltip from '../../../../../../../components/EllipsisTextWithTooltip/EllipsisTextWithTooltip';
import {
  createHouseAddress,
  createRoomRanges,
  extractNumbersFromStrings,
} from '../../../../../shared/packages/address';
import { createAcceptanceSummary } from '../../../../../shared/packages/acceptance';
import styles from './index.module.scss';

const HouseCard = ({ house, onClick, isActive, actionsSlot }) => {
  const { id, flats, countAddresses, countAcceptanceAddresses } = house;

  const handleClick = () => onClick(id);

  return (
    <li
      className={cn(styles.root, { [styles.active]: isActive })}
      onClick={isActive ? undefined : handleClick}
    >
      <div className={styles.iconCol}>
        <Icon component={NotebookIcon} className={styles.icon} />
      </div>

      <div className={styles.contentCol}>
        <div className={styles.heading}>
          <Text className={styles.title}>{createHouseAddress(house)}</Text>
          <div className={styles.actionsSlot}>{actionsSlot}</div>
        </div>

        <Text className={styles.description}>{createDescription(flats)}</Text>
        <Text className={styles.statistic}>
          {createAcceptanceSummary(countAcceptanceAddresses, countAddresses)}
        </Text>
      </div>
    </li>
  );
};

export default memo(HouseCard);

function Text({ children, className }) {
  return (
    <EllipsisTextWithTooltip as="p" className={cn(styles.text, className)}>
      {children}
    </EllipsisTextWithTooltip>
  );
}

function createDescription(flatNumbers) {
  const nums = extractNumbersFromStrings(flatNumbers);
  const ranges = createRoomRanges(nums);
  return ranges ? `Помещения ${ranges}` : undefined;
}
